'use client';

import { useRef } from 'react';

export function useCallbackRef<T>(callback: T) {
  const ref = useRef(callback);
  if (callback !== ref.current) ref.current = callback;
  return ref;
}
